var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CardButtons,{attrs:{"data-testid":"portability-requests-card","title":_vm.data.head,"description":_vm.data.title,"paragraph":_vm.data.description,"action-button-list":_setup.button},on:{"onClick":_setup.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }